import Cookies from "js-cookie";
import posthog from "posthog-js";

/**
 * Clears the core auth session data and redirects to login.
 * Used when a 401 Unauthorized response is received from the API.
 */
export const clearSessionAndRedirect = (): void => {
  // Clear core auth keys only
  localStorage.removeItem("token");
  localStorage.removeItem("userInfo");

  // Clear all cookies
  const allCookies = Cookies.get();
  for (const cookieName of Object.keys(allCookies)) {
    Cookies.remove(cookieName);
  }

  // Reset PostHog tracking
  posthog.reset();

  // Redirect to login page
  window.location.href = "/login";
};
